import React from 'react';

export function Spinner({ size = 18, color = 'var(--ai-3)' }: { size?: number; color?: string }) {
  return (
    <span className="inline-block" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 24 24" style={{ animation: 'spin 0.7s linear infinite' }}>
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeOpacity="0.18" strokeWidth="3" style={{ color }} />
        <path d="M12 3a9 9 0 0 1 9 9" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" />
      </svg>
    </span>
  );
}
export type SpinnerProps = React.ComponentProps<typeof Spinner>;
